import {
  ArrowIcon,
  BookmarkIcon,
  TimerIcon,
  ClipboardIcon,
  AdgmIcon,
} from "../../../assets/icons";
import { Divider, IconCard, InformationBox } from "../../../components";
import { useDpConfig } from "../../../contexts/dpConfig";
import { useStepper } from "../Stepper";

const InitialPage = () => {
  const { nextStep } = useStepper();
  const {
    state: { uiLocalizationData },
  } = useDpConfig();

  const iconCardItems = [
    {
      title: "Quick application",
      subtitle: "Just 10 minutes to apply",
      icon: <TimerIcon className={"cx-text-text-brand"} />,
    },
    {
      title: "Fast pre-approval",
      subtitle: uiLocalizationData.introPage.approvalBox.subtitle,
      icon: <BookmarkIcon className={"cx-text-text-brand"} />,
    },
  ];

  const helpSection = uiLocalizationData.introPage.helpSection;
  const infoDisclaimer = uiLocalizationData.introPage.infoDisclaimer;

  return (
    <div className="cx-w-full cx-flex cx-content-center cx-items-center cx-flex-col">
      <div className="cx-max-w-[960px] cx-px-2 cx-pb-10 cx-w-full cx-flex cx-flex-col cx-justify-items-start cx-gap-[2.5rem] md:cx-gap-[5rem]">
        <div className={"cx-flex cx-flex-col cx-gap-y-10"}>
          <div>
            <h2
              className={
                "cx-font-normal cx-text-3xl cx-text-neutral-darker cx-leading-[40px]"
              }
            >
              {uiLocalizationData.introPage.headline + ","}
            </h2>
            <h2 className={"cx-font-normal cx-text-3xl"}>
              {uiLocalizationData.introPage.subHeadline}
            </h2>
          </div>

          <div
            className={
              "cx-flex md:cx-flex-row cx-flex-col cx-justify-between cx-gap-6"
            }
          >
            <div className={"cx-flex md:cx-flex-row cx-gap-6 cx-basis-2/3"}>
              {iconCardItems.map((item) => (
                <div className={"cx-w-full"} key={item.title}>
                  <IconCard
                    title={item.title}
                    subtitle={item.subtitle}
                    icon={item.icon}
                  />
                </div>
              ))}
            </div>
            <div className={"cx-w-full cx-basis-1/3"}>
              <IconCard
                title={uiLocalizationData.introPage.applyBox}
                onClick={nextStep}
                icon={
                  <ArrowIcon className={"cx-animate-wiggle cx-text-white"} />
                }
              />
            </div>
          </div>
        </div>

        <Divider mobileOnly={false} />

        <div
          className={
            "cx-flex cx-justify-between cx-gap-10 md:cx-flex-row cx-flex-col"
          }
        >
          <div className={"cx-basis-1/2 cx-gap-6 cx-flex cx-flex-col"}>
            <p className={"cx-font-normal cx-text-xl"}>Required documents</p>
            <div>
              <InformationBox
                information={uiLocalizationData.introPage.requiredDocuments}
              />
            </div>
          </div>
          <div className={"cx-basis-1/2 cx-gap-6 cx-flex cx-flex-col"}>
            <p className={"cx-font-normal cx-text-xl"}>How it works</p>
            <div>
              <InformationBox
                information={uiLocalizationData.introPage.howItWorks}
              />
            </div>
          </div>
        </div>

        {helpSection && (
          <div className="cx-flex cx-flex-col cx-items-center cx-gap-2">
            <p className="cx-text-sm cx-text-neutral-darker">
              {helpSection.title}
            </p>
            <p className="cx-text-xs cx-text-text-tertiary cx-flex cx-gap-1 cx-flex-wrap cx-text-center">
              {helpSection.faqLinkUrl ? (
                <a
                  href={helpSection.faqLinkUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="cx-text-brand-primary-regular hover:cx-underline"
                >
                  {helpSection.faqLinkText}
                </a>
              ) : (
                helpSection.faqLinkText
              )}
              {helpSection.contactEmail && (
                <>
                  <span className="cx-text-muted-foreground">
                    or reach us at
                  </span>
                  <a
                    href={`mailto:${helpSection.contactEmail}`}
                    className="cx-text-brand-primary-regular hover:cx-underline"
                  >
                    {helpSection.contactEmail}
                  </a>
                </>
              )}
            </p>
          </div>
        )}

        {infoDisclaimer && (
          <div className="cx-w-screen cx-relative cx-left-1/2 cx-right-1/2 cx-ml-[-50vw] cx-mr-[-50vw] cx-bg-[#F8F8F8] cx-py-12">
            <div className="cx-max-w-[960px] cx-mx-auto cx-px-2 cx-grid md:cx-grid-cols-2 cx-gap-14">
              <div className="cx-flex cx-flex-col cx-gap-4">
                <div className="cx-flex cx-items-center cx-gap-3">
                  <ClipboardIcon className="cx-w-6 cx-h-6 cx-text-brand-primary-regular" />
                  <p className="cx-text-sm cx-font-medium cx-text-neutral-darker">
                    {infoDisclaimer.whyTitle}
                  </p>
                </div>
                <p className="cx-text-xs cx-leading-5 cx-text-text-tertiary">
                  {infoDisclaimer.whyDescription}
                </p>
              </div>
              <div className="cx-flex cx-flex-col cx-gap-4">
                <div className="cx-flex cx-items-center cx-gap-3">
                  <AdgmIcon className="cx-w-10 cx-h-10" />
                  <p className="cx-text-sm cx-font-medium cx-text-neutral-darker">
                    {infoDisclaimer.regulatedTitle}
                  </p>
                </div>
                <p className="cx-text-xs cx-leading-5 cx-text-text-tertiary">
                  {infoDisclaimer.regulatedDescription}
                  {infoDisclaimer.regulatorLinkUrl && (
                    <>
                      {" "}
                      <a
                        href={infoDisclaimer.regulatorLinkUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="cx-text-brand-primary-regular hover:cx-underline"
                      >
                        Learn more
                      </a>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InitialPage;
